import { createFileRoute, redirect } from "@tanstack/react-router";
import { WorkshopStudy } from "../../pages/Workshop/WorkshopStudy";
import {
	getStudyCourseDetails,
	getStudyWebinarDetails,
	getStudyWebinarUpcomingDetails,
	getStudyCourseUpcomingDetails,
} from "../../api/api";
import type { StudyWorkshopDetails } from "../../api/studyWorkshopDetails.types";
import { LoaderSpinner } from "@/components/ui/LoaderSpinner";
import { getAccessToken } from "@/utils/storage/authStorage";

export type StudyStatus =
	| "Kurs-online"
	| "Webinar-online"
	| "Szkolenie"
	| "Webinar"
	| "unknown";

export const Route = createFileRoute("/(app)/_app/study/$studyId")({
	component: WorkshopStudy,
	beforeLoad: async ({ context }) => {
		// Get token from context or Storage
		const token =
			(context as { token: string | null }).token || (await getAccessToken());

		if (!token) {
			redirect({
				to: "/login",
			});
		}

		return { token };
	},
	validateSearch: (
		search: Record<string, unknown>
	): { status: StudyStatus } => {
		return {
			status: (search["status"] as StudyStatus) || "unknown",
		};
	},
	loaderDeps: ({ search }) => {
		return {
			status: search.status.toLowerCase() as
				| "kurs-online"
				| "webinar-online"
				| "szkolenie"
				| "webinar"
				| "unknown",
		};
	},
	loader: async (loaderProps) => {
		const { params, deps } = loaderProps;
		let studyWorkshopDetails: StudyWorkshopDetails | undefined;
		const isCourse =
			deps.status.includes("szkolenie") || deps.status.includes("kurs");
		const isWebinar = deps.status.includes("webinar");
		const isUpcoming = deps.status.includes("online");
		if (isCourse && isUpcoming) {
			studyWorkshopDetails = await getStudyCourseUpcomingDetails(
				params.studyId
			);
		} else if (isWebinar && isUpcoming) {
			studyWorkshopDetails = await getStudyWebinarUpcomingDetails(
				params.studyId
			);
		} else if (isCourse) {
			studyWorkshopDetails = await getStudyCourseDetails(params.studyId);
		} else if (isWebinar) {
			studyWorkshopDetails = await getStudyWebinarDetails(params.studyId);
		}
		return {
			studyWorkshopDetails,
		};
	},
	pendingComponent: () => {
		return (
			<div className="flex justify-center items-center h-screen">
				<LoaderSpinner className="p-3" size={6} />
			</div>
		);
	},
	// pendingMs: 10,
});
